<template>
  <app-page>
    <template #main="{ height }">
      <div :style="{height: `${height}px`, padding: '0px 24px'}">
        <div class="title">业务账单</div>
        <el-row class="content-box mb-8" type="flex">
          <el-col :span="8">
            <div class="title-text flex">
              <icon-svg name="icon-receipt-bill" />
              <span>收款账单（含补款账单数据）</span>
            </div>
          </el-col>
          <el-col :span="12">
            <template v-if="$has('FWS-DZZX-ZDGL-SKZDDC')">
              <el-row type="flex">
                <el-col :span="5" style="padding-right: 10px; text-align: right">
                  <jr-select
                    select-style="max-width: 100%;"
                    v-model="receiptTimeType"
                    :size="formSize"
                    :options="receiptTimeTypeOptions"
                  />
                </el-col>
                <el-col :span="19">
                  <date-picker
                    :query.sync="receiptDateValue"
                    @change="dateChange"
                  />
                </el-col>
              </el-row>
              <el-row type="flex" style="margin-top: 15px;">
                <el-col :span="5" style="padding-right: 10px; text-align: right">服务商类型</el-col>
                <el-col :span="19">
                  <el-checkbox v-model="receiptServiceType" v-for="item in serviceTypeList" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                </el-col>
              </el-row>
            </template>
            <span class="mr-8" v-else>暂无权限导出</span>
          </el-col>
          <el-col :span="4" class="text-right" v-if="$has('FWS-DZZX-ZDGL-SKZDDC')">
            <page-export-button
              button-text="导出"
              exportServe="fin_receipt_receiptBillReport"
              :exportParams="exportParams"
              exportType="button"
              :checkFun="checkReceiptExport"
              trackCode='countingBill-1'
            />
          </el-col>
        </el-row>
        <el-row class="content-box" type="flex">
          <el-col :span="8">
            <div class="title-text flex">
              <icon-svg name="icon-payment-bill" />
              <span>付款账单（含退款账单数据）</span>
            </div>
          </el-col>
          <el-col :span="12">
            <template v-if="$has('FWS-DZZX-ZDGL-FKZDDC')">
              <el-row type="flex">
                <el-col :span="5" style="padding-right: 10px; text-align: right">
                  <jr-select
                    select-style="max-width: 100%;"
                    v-model="paymentTimeType"
                    :size="formSize"
                    :options="paymentTimeTypeOptions"
                  />
                </el-col>
                <el-col :span="19">
                  <date-picker
                    :query.sync="paymentDateValue"
                    @change="paymentDateChange"
                  />
                </el-col>
              </el-row>
              <el-row type="flex" style="margin-top: 15px;">
                <el-col :span="5" style="padding-right: 10px; text-align: right">服务商类型</el-col>
                <el-col :span="19">
                  <el-checkbox v-model="paymentServiceType" v-for="item in serviceTypeList" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                </el-col>
              </el-row>
              <el-row type="flex" style="margin-top: 15px;">
                <el-col :span="5" style="padding-right: 10px; text-align: right">导出类型</el-col>
                <el-col :span="19">
                  <el-radio v-model="ordersType" :label="1">按订单类型</el-radio>
                  <el-radio v-model="ordersType" :label="2">按账单类型</el-radio>
                </el-col>
              </el-row>
            </template>
            <span class="mr-8" v-else>暂无权限导出</span>
          </el-col>
          <el-col :span="4" class="text-right" v-if="$has('FWS-DZZX-ZDGL-FKZDDC')">
            <page-export-button
              button-text="导出"
              exportServe="fin_payment_paymentBillReport"
              :exportParams="paymentExportParams"
              exportType="button"
              :checkFun="checkPaymentExport"
              trackCode='countingBill-2'
            />
          </el-col>
        </el-row>
        <div class="title">渠道账单</div>
        <el-row class="content-box">
          <el-col :span="8">
            <div class="tip-text flex">
              <icon-svg name="icon-wait" />
              <span>敬请期待</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </template>
  </app-page>
</template>

<script>
export default {
  data() {
    return {
      receiptDateValue: {
        beginTime: '',
        endTime: '',
      },
      paymentDateValue: {
        beginTime: '',
        endTime: '',
      },
      ordersType: 1,
      receiptTimeType: '1',
      receiptTimeTypeOptions: [
        { value: '1', label: '创建时间' },
        { value: '2', label: '收款/补款确认时间' },
      ],
      paymentTimeType: '1',
      paymentTimeTypeOptions: [
        { value: '1', label: '创建时间' },
        { value: '2', label: '付款/退款完成时间' },
      ],
      // 服务商类型列表
      serviceTypeList: [
        { value: '1', label: '百布服务商' },
        { value: '2', label: '一批商' },
      ],
      // 收款账单-服务商类型
      receiptServiceType: ['1', '2'],
      // 付款账单-服务商类型
      paymentServiceType: ['1', '2'],
    };
  },
  computed: {
    // 收款账单（含补款账单数据） 按钮参数
    exportParams() {
      const params = {
        beginTime: this.receiptDateValue.beginTime,
        endTime: this.receiptDateValue.endTime,
        transType: '2',
        timeType: this.receiptTimeType, // 时间类型
        serviceType: (this.receiptServiceType || []).join(','), // 服务商类型
      };
      return params;
    },
    // 付款账单（含退款账单数据）按钮参数
    paymentExportParams() {
      const params = {
        beginTime: this.paymentDateValue.beginTime,
        endTime: this.paymentDateValue.endTime,
        transType: '2',
        ordersType: this.ordersType,
        timeType: this.paymentTimeType, // 时间类型
        serviceType: (this.paymentServiceType || []).join(','), // 服务商类型
      };
      return params;
    },
  },
  methods: {
    dateChange(type) {
      if (type === 1 && !this.receiptDateValue.beginTime) {
        this.receiptDateValue.endTime = '';
      }
    },
    paymentDateChange(type) {
      if (type === 1 && !this.paymentDateValue.beginTime) {
        this.paymentDateValue.endTime = '';
      }
    },
    // 收款账单（含补款账单数据）
    checkReceiptExport() {
      if ((!this.receiptDateValue.beginTime || !this.receiptDateValue.endTime)) {
        this.$message.warning('请选择导出的时间范围！');
        return false;
      }
      if (!(this.receiptServiceType && this.receiptServiceType.length > 0)) {
        this.$message.warning('请选择导出的服务商类型！');
        return false;
      }
      return true;
    },
    // 付款账单（含退款账单数据）
    checkPaymentExport() {
      if ((!this.paymentDateValue.beginTime || !this.paymentDateValue.endTime)) {
        this.$message.warning('请选择导出的时间范围！');
        return false;
      }
      if (!(this.paymentServiceType && this.paymentServiceType.length > 0)) {
        this.$message.warning('请选择导出的服务商类型！');
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .page-main {
    padding: 0 !important;
  }
  .icon-svg {
    font-size: 20px;
  }
  .el-row--flex {
    align-items: center;
  }
  .jr-select-content {
    margin: 0;
  }
}

.mb-8 {
  margin-bottom: 8px;
}
.mr-8 {
  margin-right: 8px;
}
.text-right {
  text-align: right;
}
.flex {
  display: flex;
  align-items: center;
  span {
    margin-left: 8px;
  }
}
.content-box {
  padding: 16px;
  background: #F7F9FD;
}
.title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #272728;
  line-height: 26px;
  padding: 20px 0;
}
.tip-text {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #C9CCD1;
  line-height: 20px;
}
.title-text {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4D4F51;
  line-height: 20px;
}
</style>
